import { DateFormats } from '@/models/common/date-formats';
import { format } from 'date-fns';

export {
    dateFromString,
    serializeDateToJson,
    formatDate,
    fixTimeZoneForUtc,
    roundToNextHour,
    addMinutes,
    formatTime,
};

function dateFromString(date: string) : Date {
    return new Date(Date.parse(date))
}

function serializeDateToJson(this: Date) {
    if (!this) { return ''; }

    return fixTimeZoneForUtc(this).toISOString();
}

const formatDate = (date: Date, formatStr: string = DateFormats.LongDateFormat_MMDDYYYY) => {
    if (!date) { return ''; }
    return format(date, formatStr);
}

const fixTimeZoneForUtc = (date: Date): Date => {
    return new Date(date.getTime() - date.getTimezoneOffset() * 60 * 1000);
}

const roundToNextHour = (date: Date): Date => {
    const newDate = new Date(date.getTime());
    newDate.setHours(newDate.getHours() + (newDate.getMinutes() > 0 ? 1 : 0));
    newDate.setMinutes(0);
    newDate.setSeconds(0);
    newDate.setMilliseconds(0);

    return newDate;
}

const addMinutes = (date: Date, minutes: number) => {
    return new Date(date.getTime() + minutes * 60 * 1000);
}

const formatTime = (seconds: number) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor(seconds / 60) % 60;
    const inSeconds = seconds % 60;
    return [hours, minutes, inSeconds]
        .map(v => v < 10 ? '0' + v : v)
        .join(':');
}
